import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_11: FaireProductEntity = {
  token: "driftless-studios-11",
  type: "product",
  name: '20 oz "Mom Life" Engraved Mug',
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/b28fdf56cca35d6e191c3a61d39febf448d0004fe620d4f863ebfd9e3b050c69.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 16.5,
  msrpDollars: 28,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
